import { render } from "./SubobjectView.vue?vue&type=template&id=61b49dc9"
import script from "./SubobjectView.vue?vue&type=script&lang=js"
export * from "./SubobjectView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__